import { Component, OnInit } from '@angular/core';
import { EncrypterService } from 'src/app/shared/services/encrypter.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { customJwtDecode as jwtDecode } from 'src/app/shared/helpers/custom-jwt';
import { BusinesSettingsService } from 'src/app/modules/business-settings/business-settings.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MyRequestsService } from '../my-requests.service';
import { ApprovalsService } from '../../approvals/approvals.service';

@Component({
  selector: 'app-pending-requests',
  templateUrl: './pending-requests.component.html',
  styleUrls: ['./pending-requests.component.css'],
  standalone: false
})
export class PendingRequestsComponent implements OnInit {
  pendingRequests: any[] = [];
  decoded_token: any;
  formBuilderList: any[] = [];
  selectedModuleId: number = 0;
  selectedStatus: number = -9999;
  approval_level_by_user_id_data: any[] = [];
  showSidebar = true;
  showModal = false;
  selectedRequest: any = null;
  page: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  Math = Math;
  filterKeyword: string = '';
  filterFromDate: string = '';
  filterToDate: string = '';
  filteredRequests: any[] = [];

  constructor(
    private myRequestsService: MyRequestsService,
    private _encrypterService: EncrypterService,
    private _sessionsService: SessionService,
    private router: Router,
    private _businessSettingsService: BusinesSettingsService,
    private toastr: ToastrService,
    private _approvalsService: ApprovalsService
  ) { }

  ngOnInit(): void {
    const session_obj = JSON.parse(this._sessionsService.get_user_session());
    const token = session_obj.token;
    this.decoded_token = jwtDecode(token);
    // console.log('token:',this.decoded_token)
    this.getPendingRequests();
    this.get_modules(this.decoded_token.sub_userid);
  }

  toggle() {
    this.showSidebar = !this.showSidebar;
  }

  get_modules(subuserid: any) {
    this._businessSettingsService
      .manage_approval_master({
        action: 'get_approval_module_master_empl_approval',
        accountid: this.decoded_token.tp_account_id,
        user_by: subuserid,
        approval_module_id: '2',
        emp_code: this.decoded_token.emp_code.toString(),
      })
      .subscribe({
        next: (resData: any) => {
          this.approval_level_by_user_id_data = resData.status
            ? resData.commonData
            : [];
        }
      });
  }

  getPendingRequests() {
    const moduleId = Number(this.selectedModuleId);
    const status = Number(this.selectedStatus);

    const payload: any = {
      userId: -9999,
      customerAccountId: this.decoded_token.tp_account_id,
      status: status,
      empCode: this.decoded_token.emp_code.toString()
    };

    if (moduleId !== 0) {
      payload.moduleId = moduleId;
    }

    this.myRequestsService.getPendingWorkflowRequests(payload).subscribe({
      next: (resData: any) => {
        this.pendingRequests = [];

        if (resData.statusCode) {
          const decrypted = JSON.parse(
            this._encrypterService.aesDecrypt(resData.commonData)
          );
          const data = decrypted || []; // Already proper JSON
          // console.log('Data:', data);

          this.pendingRequests = data.map((req: any) => ({
            request_name: req.requestee_name || 'N/A', // Fallback for null name
            requestid: req.requestid,
            module_name: req.approval_module_name,
            requestee_emp_code: req.requestee_emp_code,
            requestee_mobile: req.requestee_mobile,
            dob: req.dob,
            status: req.approval_status === 0 ? 0 : req.approval_status === 1 ? 1 : 2,
            created_on: req.creationdate,
            created_on_raw: new Date(req.creationdate),
            fields: Object.values(req.fields || {}).map((f: any) => {
              try {
                let fieldValue = f.field_value;

                // Safely handle missing or null field_name
                const fieldName = f.field_name ? f.field_name.toString() : '';
                const fieldType = fieldName.toLowerCase();

                // Attempt to parse JSON strings for file objects
                if (
                  typeof fieldValue === 'string' &&
                  fieldValue.trim().startsWith('{') &&
                  fieldValue.trim().endsWith('}')
                ) {
                  try {
                    const parsedValue = JSON.parse(fieldValue);
                    if (parsedValue && (parsedValue.mime || parsedValue.base64)) {
                      fieldValue = parsedValue;
                    }
                  } catch {
                    // ignore invalid JSON
                  }
                }

                // NEW: Attempt to parse JSON arrays (e.g. Table Data: [{"Col1":"Val1"}, ...])
                if (
                  typeof fieldValue === 'string' &&
                  fieldValue.trim().startsWith('[') &&
                  fieldValue.trim().endsWith(']')
                ) {
                  try {
                    const parsedArray = JSON.parse(fieldValue);
                    if (Array.isArray(parsedArray)) {
                      fieldValue = parsedArray;
                    }
                  } catch {
                    // ignore invalid JSON
                  }
                }

                if (fieldValue && typeof fieldValue === 'string') {

                  //Handle checkbox delimiter
                  if (fieldValue.includes('|#*|')) {
                    fieldValue = fieldValue.split('|#*|').map(v => v.trim());
                  }
                  // fallback for old comma-separated values - ONLY if not a JSON string
                  else if (fieldValue.includes(',') && !fieldValue.trim().startsWith('{') && !fieldValue.trim().startsWith('[')) {
                    fieldValue = fieldValue.split(',').map(v => v.trim());
                  }
                  else {
                    fieldValue = [fieldValue];
                  }
                }

                // Format date fields
                if (
                  (fieldType.includes('date') || fieldType.includes('dob') || fieldType.includes('time')) &&
                  isNaN(Number(fieldValue)) // ensure not a plain number like "80"
                ) {
                  fieldValue = this.formatFieldValue(fieldValue);
                }

                // Boolean conversion for Declaration fields
                if (fieldType.includes('declaration')) {
                  fieldValue = fieldValue === 'true' ? 'Yes' : 'No';
                }

                return {
                  name: fieldName || 'Unnamed Field',
                  label: fieldName || 'Unnamed Field',
                  value: fieldValue || '-',
                };
              } catch (e) {
                console.error("Error parsing field:", f, e);
                return {
                  name: f.field_name || 'Error Field',
                  label: f.field_name || 'Error Field',
                  value: 'Error displaying value'
                };
              }
            }),

            template_mode: req.template_mode,
            reporting_to_level: req.reporting_to_level,
            applicationlevel: req.applicationlevel
          }));
          this.filteredRequests = [...this.pendingRequests];
          this.totalRecords = this.pendingRequests.length;
        }
      },
      error: (err) => {
        console.error("Error fetching Pending Requests:", err);
        this.pendingRequests = [];
      }
    });
  }

  isTableData(value: any): boolean {
    return Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && value[0] !== null && !value[0].mime;
  }

  // Preserve original order for keyvalue pipe
  originalOrder = (a: any, b: any): number => {
    return 0;
  }

  // Parse table headers to handle nested columns (Separator: <>, >, or -)
  getTableHeaders(data: any[]): any[] {
    if (!data || data.length === 0) return [];

    const rawKeys = Object.keys(data[0]);

    // 1. Detect Separator (Prioritize specific ones)
    let separator = '';
    if (rawKeys.some(k => k.includes('<>'))) separator = '<>';
    else if (rawKeys.some(k => k.includes(' > '))) separator = ' > ';
    else if (rawKeys.some(k => k.includes(' - '))) separator = ' - ';

    const result: any[] = [];
    const groupMap: { [key: string]: any } = {};

    rawKeys.forEach(key => {
      let isGroup = false;
      let groupName = '';
      let subLabel = '';

      if (separator && key.includes(separator)) {
        const parts = key.split(separator);
        // Treat first part as group name, rest as sub-label
        groupName = parts[0];
        subLabel = parts.slice(1).join(separator);
        isGroup = true;
      }

      if (isGroup) {
        if (!groupMap[groupName]) {
          // New Group
          const groupItem = {
            header: groupName,
            isSimple: false,
            subHeaders: [{ key: key, label: subLabel }], // Store objects with label
            rowspan: 1,
            colspan: 1
          };
          groupMap[groupName] = groupItem;
          result.push(groupItem);
        } else {
          // Existing Group - append subheader
          const groupItem = groupMap[groupName];
          groupItem.subHeaders.push({ key: key, label: subLabel });
          groupItem.colspan = groupItem.subHeaders.length;
        }
      } else {
        // Simple Column
        result.push({
          header: key,
          isSimple: true,
          rowspan: 2,
          colspan: 1,
          dataKey: key
        });
      }
    });

    return result;
  }

  goToForm() {
    this.router.navigate(['form']);
  }

  openModal(req: any) {
    this.selectedRequest = req;
    this.showModal = true;
  }

  closeModal() {
    this.selectedRequest = null;
    this.showModal = false;
  }

  getFileObject(value: any) {
    if (!value) return null;

    // String values
    if (typeof value === 'string') {
      if (value.toLowerCase().endsWith('.pdf')) {
        return {
          mime: 'application/pdf',
          url: value,
          fileName: this.extractFileName(value) || 'download.pdf'
        };
      }
      if (value.match(/\.(jpeg|jpg|png|gif|png)$/i)) {
        return {
          mime: 'image/png',
          url: value,
          fileName: this.extractFileName(value) || 'image.png'
        };
      }
    }

    // Object values
    if (value && value.mime) {
      return {
        mime: value.mime,
        url: value.url || null,
        base64: value.base64 || null,
        fileName: value.fileName || value.name || 'file'
      };
    }

    return null;
  }

  extractFileName(path: string): string {
    try {
      return path.split('/').pop() || 'file';
    } catch {
      return 'file';
    }
  }

  formatFieldValue(value: any): string {
    if (value === null || value === undefined || value === '') return '-';

    // If value is a date/time string
    if (typeof value === 'string' && isNaN(Number(value)) && !isNaN(Date.parse(value))) {
      const date = new Date(value);
      const formattedDate =
        date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });

      const formattedTime =
        date.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });

      return `${formattedDate} ${formattedTime}`;
    }

    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'object') return JSON.stringify(value);

    return value.toString();
  }


  updateRequestStatus(request: any, status: number) {
    let createdBy = this.decoded_token.sub_userid;

    if (createdBy === "" || createdBy === undefined) {
      createdBy = null;
    }

    const payload = {
      application_id: request.requestid,
      approval_status: status,
      createdby: createdBy
    };

    this.myRequestsService.updateWorkflowRequest(payload).subscribe({
      next: (res: any) => {
        const statusCode = res?.statusCode === true || res?.status === 'true' || res?.status === true;
        const message =
          (res?.message && res.message) ||
          (res?.msg && res.msg) ||
          (res?.err && res.err) ||
          "Update failed";

        if (statusCode) {
          if (status == 1) { // application approved
            if (request.module_name == 'Hiring Requirement') {
              const getFieldValue = (fieldName: string) => {
                const field = request.fields.find((f: any) => f.name.toLowerCase() === fieldName.toLowerCase() || f.label.toLowerCase() === fieldName.toLowerCase());
                if (!field) return null;
                const val = field.value;
                // Handle array values (take first item if array)
                return Array.isArray(val) && val.length > 0 ? val[0] : val;
              };

              // Construct Job Post Object
              const jobTitle = getFieldValue('Job Title') || 'Developer';
              const slug = jobTitle.toString().toLowerCase().replace(/\s+/g, '-');

              let jobObj = {
                action: 'Add-job',
                customeraccountid: this.decoded_token.tp_account_id?.toString(),
                job_title: jobTitle,
                slug: slug,
                job_type: '1', // Default to Full Time ID
                job_role: '222', // Default to Developer ID
                job_sub_role: null,
                skills: [
                  { id: "4072", name: "JavaScript" }
                ],
                course: [
                  { id: "3", name: "Bachelor" }
                ],
                specialization: [
                  { id: "62", name: "BCA" }
                ],
                salary_min: getFieldValue('Monthly Salary (Min)') || getFieldValue('min_monthly_salary') || '10000',
                salary_max: getFieldValue('Monthly Salary (Max)') || getFieldValue('max_monthly_salary') || '50000',
                experience_min: getFieldValue('Experience (Min)') || getFieldValue('min_work_experience') || '1',
                experience_max: getFieldValue('Experience (Max)') || getFieldValue('max_work_experience') || '3',
                state: '10', // Default to Delhi ID
                city: '141', // Default to New Delhi ID
                pincode: getFieldValue('Pincode') || '110045',
                no_of_positions: getFieldValue('No. of Positions') || getFieldValue('num_of_vacancies') || '1',
                job_id: "",
                meta_job_title: `${jobTitle} Position | Apply Now`,
                meta_job_desc: `Apply for the ${jobTitle} position! Join our team and leverage your skills in .NET  ,JavaScript,java expert   to drive success and grow your career.`,
                job_desc: `<p>${getFieldValue('Job Description') || getFieldValue('job_description') || 'Please apply for the position if you have the skills mentioned above only.'}</p>`
              };

              this.myRequestsService.saveJobPosting(jobObj).subscribe((res: any) => {
                if (res?.statusCode) {
                  this.toastr.success('Job Post created successfully');
                } else {
                  this.toastr.error('Failed to create Job Post');
                }
              });
            } else if (request.module_name == 'Advance Salary Request Approval') { 
              const getFieldValue = (fieldName: string) => {
                const field = request.fields.find((f: any) => f.name.toLowerCase() === fieldName.toLowerCase() || f.label.toLowerCase() === fieldName.toLowerCase());
                if (!field) return null;
                const val = field.value;
                return Array.isArray(val) && val.length > 0 ? val[0] : val;
              };

              // Extracting data from the form fields
              const today = new Date();
              const sanctionDateVal = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
              const instalmentVal = '1';
              const roiVal = '0';
              const loanBillableVal ='N';
              const amountVal = getFieldValue('Amount') || getFieldValue('amount') || '0';
              const headIdVal = '9';
              //   change for production
              const subLedgerHeadNameVal = 'Advances';
              
              const empCodeValue = request.requestee_mobile + 'CJHUB' + request.requestee_emp_code + 'CJHUB' + request.dob;'';
              const createdByVal = this.decoded_token.sub_userid || this.decoded_token.tp_account_id?.toString();
              const productTypeIdVal = '2';
              const createdByIpVal =  '11';
              const customerAccountIdVal = this.decoded_token.tp_account_id?.toString();

              const advancePayload = {
                sanctionDate: sanctionDateVal,
                instalment: instalmentVal.toString(),
                roi: roiVal.toString(),
                loanBillableOrNonBillable: loanBillableVal,
                empCode: empCodeValue,
                amount: amountVal.toString(),
                headId: headIdVal.toString(),
                subLedgerHeadName: subLedgerHeadNameVal,
                createdBy: createdByVal,
                productTypeId: productTypeIdVal.toString(),
                createdByIp: createdByIpVal,
                customerAccountId: customerAccountIdVal,
                voucherOrigin:"Advnace Request Form"
              };
             // return console.log(advancePayload);
              // We also include the keys the Node API might expect directly, just in case
              advancePayload['loanSanctionDate'] = advancePayload.sanctionDate;
              advancePayload['loanAmount'] = advancePayload.amount;
              advancePayload['loanInstalment'] = advancePayload.instalment;
              advancePayload['loanROI'] = advancePayload.roi;
              advancePayload['isBillable'] = advancePayload.loanBillableOrNonBillable;
              advancePayload['headIdVal'] = advancePayload.headId;

              this._approvalsService.SaveAdvanceAndLoanVoucher(advancePayload).subscribe((res: any) => {
                console.log(res);
                if (res?.statusCode) {
                  this.toastr.success('Application approved Advance Voucher created successfully');
                } else {
                  this.toastr.error('Failed to create Advance Voucher: ' + res?.message);
                }
              });
            }
          }
          this.toastr.success(message);
          this.getPendingRequests();
          this.closeModal();
        } else {
          this.toastr.error(message);
        }
      },
      error: (err: any) => {
        console.error("API Error:", err);
        const errorMsg =
          (err && (typeof err === "string" ? err : err.error?.message || err.message)) ||
          "API call failed, please try again.";
        this.toastr.error(errorMsg);
      }
    });
  }

  applyFilter() {
    this.filteredRequests = this.pendingRequests.filter(req => {
      let matchesKeyword = true;
      let matchesFromDate = true;
      let matchesToDate = true;
      let matchesModule = true;
      let matchesStatus = true;

      // Keyword
      if (this.filterKeyword) {
        const keyword = this.filterKeyword.toLowerCase();
        matchesKeyword =
          req.request_name?.toLowerCase().includes(keyword) ||
          req.module_name?.toLowerCase().includes(keyword) ||
          (req.status === 0 && 'pending'.includes(keyword)) ||
          (req.status === 1 && 'approved'.includes(keyword)) ||
          (req.status === 2 && 'rejected'.includes(keyword));
      }

      // Module Filter
      if (this.selectedModuleId && this.selectedModuleId !== 0) {
        matchesModule = req.module_name &&
          this.approval_level_by_user_id_data.some(
            m => m.approval_module_id == this.selectedModuleId &&
              m.approval_module_name === req.module_name
          );
      }

      // Status Filter
      if (this.selectedStatus !== -9999) {
        matchesStatus = req.status === this.selectedStatus;
      }

      // Date filters
      if (this.filterFromDate) {
        const fromDate = new Date(this.filterFromDate);
        matchesFromDate = req.created_on_raw >= fromDate;
      }

      if (this.filterToDate) {
        const toDate = new Date(this.filterToDate);
        matchesToDate = req.created_on_raw <= toDate;
      }

      return matchesKeyword && matchesFromDate && matchesToDate && matchesModule && matchesStatus;
    });

    this.page = 1;
    this.totalRecords = this.filteredRequests.length;
  }


  resetFilter() {
    this.filterKeyword = '';
    this.filterFromDate = '';
    this.filterToDate = '';
    this.selectedModuleId = 0;
    this.selectedStatus = -9999;
    this.filteredRequests = [...this.pendingRequests];
    this.page = 1;
    this.totalRecords = this.pendingRequests.length;
  }


  filterSidebarOpen = false;

  toggleFilterSidebar() {
    this.filterSidebarOpen = !this.filterSidebarOpen;
  }
}
